import React, { Component } from 'react';
import LoadingPanel from '../utility_components/LoadingPanel';
import BaseError from '../utility_components/errors/BaseError';
import {RadixLoading} from "../ui/primitives/RadixLoading";
import {CircleIcon} from "@radix-ui/react-icons";
const RecurveBaseComponent = function(props) {
    /**
     * Checks to see if there is a directive to display any errors or loading components before proceeding with render
     */
    let hasErrors = props.error;
    let renderCheck = function() {
        if(props.hasServerError) {
            let serverError = {
                friendly: {
                name: 'Server Error',
                description: `We weren't able to complete your request, please refresh the page and try again.`
                }
            };
            return <BaseError proceedFunction={props.errorProceedFunction} proceedText={props.errorProceedText} closeFunction={props.errorCloseFunction} closeText={props.errorCloseText} popup={props.hasPopupError} error={serverError}/>;
        }
        if(hasErrors) { // If errors short-circuit, return BaseError
            return <BaseError proceedFunction={props.errorProceedFunction} proceedText={props.errorProceedText} closeFunction={props.errorCloseFunction} closeText={props.errorCloseText} popup={props.hasPopupError} error={props.error} />;
        }
        if(props.loading) { // If loading, return LoadingPanel
            return <RadixLoading label={"Loading..."} fullScreen={true} icon={<CircleIcon />} iconAction={"rotate"} />
        }
        return false;
    }
        //This block MUST be at the beginning of EVERY render call that needs to display loading or error components
        if(renderCheck()) {
            return renderCheck();
        }
        return props.content ? props.content : <div />;
};
export default RecurveBaseComponent;
